import { env } from '../../../lib/env';

export const AUTH_BUTTONS_WIDTH_DESKTOP_CLASSNAME = 'sm:w-[205px] sm:gap-4';
export const AUTH_BUTTONS_WIDTH_MOBILE_CLASSNAME = 'w-auto xs:w-[172px] gap-2';

export const AUTH_BUTTONS_ROOT_URL =
  env.NEXT_PUBLIC_DEPLOYABLE_ENV === 'prod'
    ? 'https://www.nerdwallet.com'
    : 'https://stage.nerdwallet.biz';
